import { Space } from 'antd';
import DataSourceIcon from 'components/DataSourceIcon';
import React from 'react';
import { DataSourceType } from 'shared/prisma/types';

const DataSourceTypeLabel = ({ type }) => {
  let title;

  if (type === DataSourceType.Website) {
    title = 'Website';
  }
  if (type === DataSourceType.Cx) {
    title = 'Customer Experience';
  }

  return title ? (
    <Space>
      <DataSourceIcon type={type} />
      {title}
    </Space>
  ) : null;
};

export default DataSourceTypeLabel;
